import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'core/ui/atoms';
import Money from 'core/api/Money';

const RowItem = ({ title, value }) => {
  return (
    <Container direction='row' justifyContent='space-between'>
      <Flex direction='row'>
        <Spacer />
        <Flex direction='column'>
          <Title>{title}</Title>
        </Flex>
      </Flex>
      <Title>{Money(value).toFormat('$0,0') || 0}</Title>
    </Container>
  );
};

RowItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
};

const Container = styled(Flex)`
  padding-left: 32px;
  padding-right: 15px;
  width: 100%;
`;

const Spacer = styled(Box)`
  width: 10px;
`;

const Title = styled(Text)`
  font-size: 16px;
  font-weight: 800;
  line-height: 135%;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export default RowItem;
